export const Field = ({ label, as = "input", testId, className = "", ...props }) => {
  const Tag = as;
  return (
    <label className={`block ${className}`}>
      <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#A3B2BC]">{label}</span>
      <Tag data-testid={testId} className="sw-input mt-2" {...props} />
    </label>
  );
};
